// Shared email length contract (RFC 5321 max path length)
export const EMAIL_MAX_LENGTH = 254;
export const EMAIL_TOO_LONG_MESSAGE = 'Email address must not exceed 254 characters.';

export const getEmailLengthError = (email) =>
  (email || '').length > EMAIL_MAX_LENGTH ? EMAIL_TOO_LONG_MESSAGE : null;
